import { Component, Input, OnInit } from '@angular/core';
import { ChartData, ChartOptions, ChartType } from 'chart.js';
import { ApiServiceBase } from 'src/app/Services/api.service.base';

@Component({
    selector: 'app-permitusageserieschart',
    templateUrl: './permitusageserieschart.component.html',
    styleUrls: ['./permitusageserieschart.component.scss'],
    standalone: false
})
export class PermitUsageSeriesChartComponent implements OnInit {
    @Input()
    public Title : string = "Permit Usage";
    @Input()
    public Period : string = "today";
    @Input()
    public ChartType : string = "line";
    @Input()
    public Height : number = 100;

    public Url : string= "";
  
    public ChartOptions : ChartOptions = {
      elements: {
        line: {
          tension: 0.2
        }
      },
      scales:{
        yAxes:{
          beginAtZero: true,
          ticks: {
            precision : 0
          }
        }
      },
      plugins: {
        legend : { display: false }
      }
    };
    public ChartData : ChartData = {
      datasets: [],
    };
    public ChartColors: string[] = [
      'green'
    ];
  
    constructor(private apiService : ApiServiceBase) { }
  
    ngOnInit(): void {

      this.Url = 'parking/permitusage/series/' + this.Period
      

      this.apiService.Get<any>(this.Url).then(result => {
        this.ChartData =  {
          datasets: [{
                  data: result.Values,
                  label: 'Permits applied',
                  pointBackgroundColor: ['green'],
                  pointBorderColor: ['green'],
                  backgroundColor: ['green'],
                  borderColor: ['green']
          }],
          labels: result.Labels,
        };
      });
    }
  
  }
  
